/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '../../../../../application';
import { OrganisationProfilePageService } from '@/pages/OrganisationProfile/services';
import { toast } from 'react-hot-toast';

const MODULE_NAME = 'roeCompanySubmit.machines.states';

const getSrv = () => {
  return vappContainer.get<OrganisationProfilePageService>(
    OrganisationProfilePageService.displayName
  );
};

export const roeCompanySubmit = async (context: any, event: any) => {
  console.log(`in roeCompanySubmit state :`, event);
  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();
      console.log(`payload in roeCompanySubmit ::::`, event?.payload);
      console.log("roecheckkkk---3", event?.payload?.submit)
      
      const data: any = await src.agent.createroeCompanySetup(event?.payload);
      console.log("roecheckkkk---4", data)


      if (data) {
        // toast.success(context['CREATE_DRAFT_APPLICATION_SUCCESS']?.message);
        return resolve({
          key: 'CREATE_DRAFT_ROE_APPLICATION_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        // toast.error(context['CREATE_DRAFT_APPLICATION_ERROR']?.message);
        return reject({
          key: 'CREATE_DRAFT_ROE_APPLICATION_ERROR',
          value: 'Invite Failed',
        });
      }
    } catch (err: any) {
      // toast.error(context['CREATE_DRAFT_APPLICATION_ERROR']?.message);

      return reject({
        key: 'CREATE_DRAFT_ROE_APPLICATION_ERROR',
        value: err?.message,
      });
    }
  });
};
